import type { Lawyer } from '@domain/lawyer/model';
import type { DisciplinarySalesHandling } from '@shared/types/lawyer';

type DisciplinarySalesSignalSource = Pick<Lawyer, 'disciplinary_sales_handling'>;

const DISCIPLINARY_CONTACT_CAUTION_BADGE_LABELS = {
  normal: null,
  needs_review: '懲戒: 要確認',
  stop_contact: '懲戒: 接触停止',
} satisfies Record<DisciplinarySalesHandling, string | null>;

export function hasDisciplinaryContactCaution(
  lawyer: DisciplinarySalesSignalSource,
): boolean {
  return disciplinaryContactCautionBadgeLabel(lawyer) !== null;
}

export function disciplinaryContactCautionBadgeLabel(
  lawyer: DisciplinarySalesSignalSource,
): string | null {
  return (
    DISCIPLINARY_CONTACT_CAUTION_BADGE_LABELS[
      lawyer.disciplinary_sales_handling
    ] ?? null
  );
}
